module.exports.sandboxParams =
  'allow-scripts allow-forms allow-popups allow-same-origin allow-popups-to-escape-sandbox allow-modals allow-presentation allow-storage-access-by-user-activation allow-downloads';
